const state = {
  colorListTrend: [
    '#5096FA',
    '#B8DCFF'
  ],
  colorListBar: [
    '#5096FA',
    '#B8DCFF',
    '#8378EA',
    '#fc8452'
  ],
  colorListPie: [
    '#5096FA',
    '#7ac5d8',
    '#fc8452',
    '#ff8177',
    '#ffad4f',
    '#b49fda',
    '#cf556c'
  ],
  colorList3: [
    '#5096FA',
    '#3CD38E',
    '#FFC65E',
    '#ff9f7f',
    '#32C5E9',
    '#8378EA'
  ]
}
const mutations = {
}
const actions = {
}
export default {
  namespaced: true,
  state,
  mutations,
  actions
}
